import { render, staticRenderFns } from "./SubgroupItineraryItemCopyForm.vue?vue&type=template&id=0b50c2b5&"
import script from "./SubgroupItineraryItemCopyForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupItineraryItemCopyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports